<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="currentColor">
        <path
            d="M18.75 15.05C19.8546 15.05 20.75 14.1546 20.75 13.05C20.75 11.9454 19.8546 11.05 18.75 11.05C17.6454 11.05 16.75 11.9454 16.75 13.05C16.75 14.1546 17.6454 15.05 18.75 15.05Z"
            fill="currentColor" />
        <path
            d="M12 13.05C13.1046 13.05 14 12.1546 14 11.05C14 9.94542 13.1046 9.04999 12 9.04999C10.8954 9.04999 10 9.94542 10 11.05C10 12.1546 10.8954 13.05 12 13.05Z"
            fill="currentColor" />
        <path
            d="M5.25 15.05C6.35457 15.05 7.25 14.1546 7.25 13.05C7.25 11.9454 6.35457 11.05 5.25 11.05C4.14543 11.05 3.25 11.9454 3.25 13.05C3.25 14.1546 4.14543 15.05 5.25 15.05Z"
            fill="currentColor" />
        <path
            d="M21.9983 11.3C21.8483 11.3 21.6983 11.26 21.5683 11.16L12.7183 4.95004C12.2883 4.65004 11.7083 4.65004 11.2783 4.95004L2.42834 11.16C2.08834 11.4 1.61834 11.32 1.38834 10.98C1.14834 10.64 1.22834 10.17 1.56834 9.94004L10.4183 3.72004C11.3683 3.06004 12.6383 3.06004 13.5783 3.72004L22.4283 9.93004C22.7683 10.17 22.8483 10.64 22.6083 10.97C22.4583 11.18 22.2283 11.29 21.9883 11.29L21.9983 11.3Z"
            fill="currentColor" />
        <path
            d="M12 13.8C9.66 13.8 7.75 15.71 7.75 18.05V21.55C7.75 21.96 8.09 22.3 8.5 22.3H15.5C15.91 22.3 16.25 21.96 16.25 21.55V18.05C16.25 15.71 14.34 13.8 12 13.8Z"
            fill="currentColor" />
        <path
            d="M6.75 21.55V18.05C6.75 17.37 6.89 16.72 7.13 16.13C6.63 15.92 6.08 15.8 5.5 15.8C3.16 15.8 1.25 17.71 1.25 20.05V21.55C1.25 21.96 1.59 22.3 2 22.3H6.93C6.82 22.07 6.75 21.82 6.75 21.55Z"
            fill="currentColor" />
        <path
            d="M18.5011 15.8C17.9211 15.8 17.3811 15.92 16.8711 16.13C17.1111 16.73 17.2511 17.37 17.2511 18.05V21.55C17.2511 21.82 17.1811 22.07 17.0711 22.3H22.0011C22.4111 22.3 22.7511 21.96 22.7511 21.55V20.05C22.7511 17.71 20.8411 15.8 18.5011 15.8Z"
            fill="currentColor" />
    </svg>
</template>